var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PickBackground',{attrs:{"objectKey":"gr_detail","type":"good_receive"}})}
var staticRenderFns = []

export { render, staticRenderFns }